import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { guidFor } from '@ember/object/internals'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon.gts'

interface Signature {
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
}

export class ExemplarBlock extends Component<Signature> {
  @tracked isOpen = true

  get id() {
    return guidFor(this)
  }

  toggle = () => {
    this.isOpen = !this.isOpen
  }

  <template>
    <div
      data-test-exemplar-block
      class="mt-[30px] flex w-full flex-col items-center border-2 border-[#b0edf5] bg-[#f7feff]"
    >
      <button
        type="button"
        data-test-toggle-button
        class="relative mt-[-23px] mb-3 ml-[-5px] w-[101%] rounded-3xl bg-[#b0edf5] p-1 text-center text-lg font-bold"
        aria-expanded={{if this.isOpen "true" "false"}}
        aria-controls="{{this.id}}-content"
        {{on "click" this.toggle}}
      >
        {{t "pages.excitingWritingIdeas.previews.writingSample"}}
        <div class="absolute inset-y-0 right-0 mr-2 flex w-6 items-center">
          {{#if this.isOpen}}
            <PhosphorIcon @icon="phosphor-caret-up" />
          {{else}}
            <PhosphorIcon @icon="phosphor-caret-down" />
          {{/if}}
        </div>
      </button>
      {{#if this.isOpen}}
        <div id="{{this.id}}-content" class="w-full">
          {{yield}}
        </div>
      {{/if}}
    </div>
  </template>
}

export default ExemplarBlock
